import { Button } from "@mui/material";
import strings from "global/constants/StringConstants";
import { fillCopy } from "helpers/methods";
import styles from "../ContractCompare.styles";
import t from "../ContractCompare.tokens";
import { CompareGlyph } from "./ContractCompareIcons";

interface CompareButtonProps {
  /** Both versions chosen and valid, no request out, no countdown, the plan and role allow it. */
  canCompare: boolean;
  /** Seconds left on a busy answer: the button counts down ("Compare · 5"). 0 when none. */
  busySeconds: number;
  onCompare: () => void;
}

/**
 * "Compare", the page's one primary action. It sits in the page header, on the right (the picker view only), and
 * scrolls with the page. Disabled until both versions are valid; counts down while the service says it is busy.
 */
const CompareButton = ({ canCompare, busySeconds, onCompare }: CompareButtonProps) => {
  const page = strings.contractCompare.page;
  const label = busySeconds > 0 ? fillCopy(page.compareBusy, { seconds: busySeconds }) : page.compare;
  return (
    <Button
      id="compare_versions_btn"
      variant="contained"
      size="large"
      disabled={!canCompare}
      onClick={onCompare}
      startIcon={<CompareGlyph sx={{ width: t.compare.icon, height: t.compare.icon }} />}
      sx={styles.compareButton}
    >
      {label}
    </Button>
  );
};

export default CompareButton;
